<template>
  <div class="catalog-upload">
    <div v-if="image" class="catalog-upload__preview">
      <img :src="image.url" :alt="label" />
      <button type="button" :disabled="disabled || busy" @click="$emit('update:modelValue', null)">Remover</button>
    </div>
    <label class="catalog-upload__button" :class="{ 'is-disabled': disabled || busy }">
      <i class="ph ph-upload-simple" aria-hidden="true"></i>
      {{ busy ? 'Enviando imagem…' : image ? 'Trocar imagem' : label }}
      <input type="file" accept="image/jpeg,image/png,image/webp" :disabled="disabled || busy" @change="upload" />
    </label>
    <small v-if="hint">{{ hint }}</small>
    <small v-if="error" role="alert" class="catalog-upload__error">{{ error }}</small>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, ref } from 'vue';
import { catalogApi, catalogError } from '@/services/catalog';

const props = defineProps({ modelValue: { type: Object, default: null }, kind: { type: String, required: true }, label: { type: String, default: 'Enviar imagem' }, hint: { type: String, default: 'JPEG, PNG ou WebP, até 5 MB.' }, disabled: Boolean });
const emit = defineEmits(['update:modelValue', 'busy']);
const image = computed(() => props.modelValue);
const busy = ref(false);
const error = ref('');
async function upload(event) {
  const file = event.target.files?.[0];
  event.target.value = '';
  if (!file) return;
  error.value = '';
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
    error.value = 'Escolha uma imagem JPEG, PNG ou WebP de até 5 MB.';
    return;
  }
  busy.value = true;
  emit('busy', true);
  try { emit('update:modelValue', await catalogApi.upload(file, props.kind)); }
  catch (e) { error.value = catalogError(e); }
  finally { busy.value = false; emit('busy', false); }
}
</script>

<style scoped>
.catalog-upload { display: grid; gap: 9px; }
.catalog-upload__preview { position: relative; width: 100%; height: 140px; background: #f3f6f8; border: 1px solid #e1e8ed; border-radius: 12px; padding: 10px; }
.catalog-upload__preview img { width: 100%; height: 100%; object-fit: contain; }
.catalog-upload__preview button { position: absolute; right: 8px; bottom: 8px; border: 1px solid #e1e8ed; background: #fff; border-radius: 7px; font-size: 12px; padding: 5px 9px; color: #b53535; }
.catalog-upload__button { cursor: pointer; display: flex; gap: 8px; align-items: center; justify-content: center; border: 1px dashed #b6c9c4; border-radius: 10px; padding: 12px; color: #15785f; background: #f5fbf8; font-weight: 600; }
.catalog-upload__button input { display: none; }
.catalog-upload small { color: #788393; font-size: 12px; }
.catalog-upload small.catalog-upload__error { color: #b53535; }
.is-disabled { opacity: .6; cursor: wait; }
</style>
